import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCustomPagination as selectPagination, setCustomPagination as setPagination } from "../../features/paginationStore";

const Pagination = ({ pageKey, totalPages, className }) => {
  const dispatch = useDispatch();
  const { page, page_size } = useSelector((state) => selectPagination(state, pageKey));

  useEffect(() => {
    const maxPage = Math.max(1, totalPages);
    if (page > maxPage) {
      dispatch(setPagination({ key: pageKey, page: maxPage }));
    }
  }, [totalPages, page, pageKey, dispatch]);

  const updatePage = (newPage) => {
    dispatch(setPagination({ key: pageKey, page: newPage }));
  };

  const updatePageSize = (newSize) => {
    dispatch(setPagination({ key: pageKey, page_size: newSize, page: 1 }));
  };

  const getPageRange = () => {
    const range = [];
    const start = Math.max(1, page - 2);
    const end = Math.min(totalPages, page + 2);
    for (let i = start; i <= end; i++) range.push(i);
    return range;
  };

  return (
    <nav className={`bg-white px-4 pb-6 flex items-center justify-between sm:px-6 ${className}`}>
      <div className="hidden sm:block">
        <label htmlFor="pageSize" className="text-sm text-gray-700 mr-2">
          Items per page:
        </label>
        <select
          id="pageSize"
          value={page_size}
          onChange={(e) => updatePageSize(Number(e.target.value))}
          className="border border-gray-300 rounded-md px-3 py-1 text-sm"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>

      {/* Right side: Pagination */}
      <div className="flex justify-between sm:justify-end gap-1">
        <button
          onClick={() => updatePage(page - 1)}
          disabled={page === 1}
          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white ${page === 1 || totalPages === 0 ? "opacity-50" : "hover:bg-gray-50 hover:text-gray-500"
            }`}
        >
          Previous
        </button>

        <div className="flex space-x-2">
          {page > 4 && (
            <>
              <button
                onClick={() => updatePage(1)}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${page === 1 ? "bg-light-blue text-white" : "text-gray-700"
                  }`}
              >
                1
              </button>
              <button
                onClick={() => updatePage(2)}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${page === 2 ? "bg-light-blue text-white" : "text-gray-700"
                  }`}
              >
                2
              </button>
              <span className="px-2 text-gray-500 text-2xl flex">...</span>
            </>
          )}

          {getPageRange().map((p) => (
            <button
              key={p}
              onClick={() => updatePage(p)}
              className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${page === p ? "bg-light-blue text-white" : "text-gray-700"
                }`}
            >
              {p}
            </button>
          ))}
        </div>

        <button
          onClick={() => updatePage(page + 1)}
          disabled={page === totalPages || totalPages === 0}
          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white ${page === totalPages || totalPages === 0
            ? "opacity-50"
            : "hover:bg-gray-50 hover:text-gray-500"
            }`}
        >
          Next
        </button>
      </div>
    </nav>
  );
};

export default Pagination;
